import { Link } from "react-router-dom";
import WeatherSourceBadge from "./WeatherSourceBadge.jsx";
import { WEATHER_TRANSPARENCY_PAGE } from "../../../constants/weatherPublicCopy.js";

const WeatherSourceDetailModal = ({ source, isOpen, onClose }) => {
  if (!isOpen || !source) {
    return null;
  }

  return (
    <div className="weather-source-detail-modal" role="presentation" onClick={onClose}>
      <div
        className="weather-source-detail-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="weather-source-detail-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="weather-source-detail-modal__header">
          <h2 id="weather-source-detail-title">{source.title}</h2>
          <button
            type="button"
            className="weather-source-detail-modal__close"
            onClick={onClose}
            aria-label="Close source details"
          >
            ×
          </button>
        </div>
        <WeatherSourceBadge tone={source.badgeTone} label={source.badgeLabel} />
        <p>{source.body}</p>
        <dl className="weather-public-source-meta">
          {source.publicUseCase ? (
            <>
              <dt>Use</dt>
              <dd>{source.publicUseCase}</dd>
            </>
          ) : null}
          {source.publicCoverage ? (
            <>
              <dt>Coverage</dt>
              <dd>{source.publicCoverage}</dd>
            </>
          ) : null}
          {source.publicLimitations ? (
            <>
              <dt>Limitation</dt>
              <dd>{source.publicLimitations}</dd>
            </>
          ) : null}
          {source.publicAttribution ? (
            <>
              <dt>Attribution</dt>
              <dd>{source.publicAttribution}</dd>
            </>
          ) : null}
        </dl>
        <p className="weather-source-detail-modal__more">
          <Link to={WEATHER_TRANSPARENCY_PAGE.path} onClick={onClose}>
            Full weather source transparency
          </Link>
        </p>
      </div>
    </div>
  );
};

export default WeatherSourceDetailModal;
